
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Arrows',
    setup() {
        const handleClick = () => {
            const el = document.querySelector('.landing__hero')
            const top = el?.scrollHeight

            window.scrollTo({
                top: top,
                left: 0,
                behavior: 'smooth',
            })
        }

        return {
            handleClick,
        }
    },
})
